export default "__VITE_ASSET__C9Java9I__"